export default __webpack_public_path__ + "static/media/coin_uni.256129dd.svg";